import { __awaiter } from "tslib";
/**
 * @ComponentFor Avensia.Shop.Features.Pantries.Pages.List.Toolbar.StartDialog
 */
import React from "react";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
import Modal from "Shared/Modal";
import { setFeedback } from "SiteLayout/GenericFeedbackBar/action-creators";
import { startInvent } from "./../../../action-creators";
import Dialog, { DialogType } from "Shared/Dialog";
import { getDetails } from "Shared/ListItem/action-creators";
function StartDialog(props) {
    const onConfirm = () => __awaiter(this, void 0, void 0, function* () {
        return yield Promise.all(props.selectedLists.map((pantry) => __awaiter(this, void 0, void 0, function* () {
            return props.getDetails(pantry.id, false).then(() => {
                return props.startInvent(pantry.id).catch(() => {
                    setFeedback({
                        text: translate("/Account/ProductList/StartInventError"),
                        type: "error",
                    });
                });
            });
        })));
    });
    const text = translate("/Account/ProductList/ActionOptions/Dialogs/StartTextLong", "<strong>", props.selectedLists.length, props.totalAmountOfPantries, "</strong>");
    return (React.createElement(Modal, { title: translate("/Account/ProductList/ActionOptions/DropDown/StartInvent"), isOpen: props.isOpen, onClose: props.closeModal, fadeDesign: true, reserveSpaceForCloseButton: true },
        React.createElement("p", { dangerouslySetInnerHTML: { __html: text } }),
        React.createElement(Dialog, { type: DialogType.OkCancel, onConfirm: onConfirm, onCancel: props.closeModal, onStatusWasFulfilled: props.closeModal, customAcceptText: translate("/Account/ProductList/ActionOptions/Dialogs/Start") })));
}
export default connect((state) => ({}), (dispatch) => ({
    startInvent: (listId) => dispatch(startInvent(listId)),
    setFeedback: (data) => dispatch(setFeedback(data)),
    getDetails: (listId) => dispatch(getDetails(listId)),
}))(StartDialog);
